import React, { useState } from 'react';
import AutoOpenPagesPresetDropdown from './AutoOpenPagesPresetDropdown';
import './AutoOpenPagesPresetModal.css';

const AutoOpenPagesPresetModal = ({ isOpen, onClose, onApply, currentValue }) => {
  const [selectedPreset, setSelectedPreset] = useState(null);

  const handleApply = () => {
    if (selectedPreset) {
      onApply(selectedPreset);
      onClose();
    }
  };

  const handleClose = () => {
    setSelectedPreset(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="auto-open-pages-preset-modal-overlay">
      <div className="auto-open-pages-preset-modal">
        <div className="auto-open-pages-preset-modal-header">
          <h3>Select Auto Open Pages Preset</h3>
          <button 
            className="auto-open-pages-preset-modal-close"
            onClick={handleClose}
          >
            ×
          </button>
        </div>
        <div className="auto-open-pages-preset-modal-body">
          <p>Choose a preset to apply to the auto_open_pages field:</p>
          <AutoOpenPagesPresetDropdown
            value={selectedPreset}
            onChange={setSelectedPreset}
            placeholder="Select a preset..."
          />
          {selectedPreset && (
            <div className="auto-open-pages-preset-preview">
              <strong>Preview:</strong>
              <ul>
                {Array.isArray(selectedPreset) ? selectedPreset.map((item, index) => (
                  <li key={index}>{item}</li>
                )) : (
                  <li>{selectedPreset}</li>
                )}
              </ul>
            </div>
          )}
        </div>
        <div className="auto-open-pages-preset-modal-footer">
          <button 
            className="auto-open-pages-preset-modal-cancel"
            onClick={handleClose}
          >
            Cancel
          </button>
          <button 
            className="auto-open-pages-preset-modal-apply"
            onClick={handleApply}
            disabled={!selectedPreset}
          >
            Apply Preset
          </button>
        </div>
      </div>
    </div>
  );
};

export default AutoOpenPagesPresetModal;
